/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_CONTACTS_REQUEST]: state => {
    state.loadingContacts = true;
    state.loadingContactsFailed = false;
    state.loadingContactsSucceeded = false;
    state.loadingContactsErrors = null;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/contacts/mutations.js